module.exports = __webpack_public_path__ + "static/media/Equipment-2.d7f22121.jpg";